export default {"src":"/_next/static/media/hardhat.bb8aa39c.svg","height":136,"width":212,"blurWidth":0,"blurHeight":0};